import React, { useState, useEffect } from 'react'
import MemberLayout from '../../../layouts/MemberLayout'
import { Box, Title, Grid, Card, Skeleton, Text, Image, Button, Modal } from '@mantine/core' 
import { getTemplateMember } from '../../../services/template'
import NoImage from '../../../assets/img/no-image.png'
import { getImageFile } from '../../../services/fileImage'
import classes from '../MemberPage.module.css'
import DetailTemplate from '../../../components/pages/Member/Template/DetailTemplate'

const Template = () => {
  const [ loading, setLoading ] = useState(true)
  const [dataTemplate, setDataTemplate] = useState([])
  const [openDetail, setOpenDetail] = useState(false)
  const [templateId, setTemplateId] = useState(null)

  const handleTemplateUser = async () => {
    setLoading(true)
    try {
      const response = await getTemplateMember()
      setDataTemplate(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleTemplateUser()
    // eslint-disable-next-line
  }, [])

  const onCloseDetailTemplate = () => {
    setOpenDetail(false)
    setTemplateId(null)
  }

  const loadingData = (number) => Array.from({ length: number }, (_, i) => {
    return (
      <Grid.Col span={{ base: 12, lg: 3 }} key={i}>
        <Card shadow='sm' padding='lg' radius='md' withBorder>
          <Card.Section>
            <Skeleton height={400} width="100%" />
          </Card.Section>
        </Card>
      </Grid.Col>
    )
  })

  const mappingDataTemplate = (data) => {
    if (data.length > 0) {
      const templateList = data.map((val, index) => {
        return (
          <Grid.Col span={{ base: 12, lg: 3 }} key={index}>
            <Card className={classes.programCard} shadow="sm" radius="lg" withBorder>
              <Card.Section>
                <Image src={val.eventSchedule.event.eventImages.length > 0 ? getImageFile(val.eventSchedule.event.eventImages[0].filepath) : NoImage} />
              </Card.Section>
              <Box className={classes.contentCard}>
                <Text fw='bold' fz={14} lineClamp={2} h={45}>{val.eventSchedule.event.name}</Text>
              </Box>
              <Box mt={10} mb={4}>
                <Button size='xs' color='red.6' fullWidth mb={4} onClick={() => [setOpenDetail(true), setTemplateId(val.id)]}>Detail</Button>
              </Box>
            </Card>
          </Grid.Col>
        )
      })
      return templateList
    } else {
      return (
        <Grid.Col span={12}>
          <Box ta='center' py={120}>
            <Text c="dark">Anda belum memiliki template apapun</Text>
          </Box>
        </Grid.Col>
      )
    }
  }

  return (
    <MemberLayout>
      <Box py={12}>
        <Title order={2} className={classes.titlePage}>Template Saya</Title>
        <Box mt={30}>
          <Grid gutter='xl' className={classes.gridProgramCard} align="center">
            {loading ? loadingData(4) : mappingDataTemplate(dataTemplate)}
          </Grid>
        </Box>
      </Box>
      <Modal opened={openDetail} onClose={onCloseDetailTemplate} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Detail Template</Text>} withCloseButton={false}>
        <DetailTemplate idTemplate={templateId} onCloseModal={onCloseDetailTemplate} />
      </Modal>
    </MemberLayout>
  )
}

export default Template